/**
 * NosRobot -- Web-based Go Robot
 * Copyright (c) 2011, Tan tianzuo <tantianzuo@gmail.com> (http://www.wuzheng.org)
 * All right reserved.
 * modified 2019
 *  整合nos_ispointok
 */
var block,
  pt,
  color,
  key;
var WGLogic = function () {
  this.init.apply(this, arguments);
};
WGLogic.prototype = {
  WHITE: 1,
  BLACK: 0,
  EMPTY: -1,

  init: function (boardSize, onKillStone) {
    //console.log("WGLogic init");
    this.boardSize = boardSize || 19;
    this.step = 0;//第几步
    this.steps = [];//保存第几步下棋的位置，第i步下棋位置为(steps[i].x,steps[i].y);
    this.last_kill_pt = null;  //上一手的提子（仅记录一个子的情况，以便做打劫判断）
    //this.stones = this.makeBoardArray(this.EMPTY);
    this.stones = [];//保存已经下过的棋子，如第三行，第四列为黑棋，则stones[(3-1)*boardSize+(4-1)]=-1;
    this.captures = {
      W: 0,
      B: 0
    };
    //this.captures.W = 0;//被吃白棋
    //this.captures.B = 0;//被吃黑棋
    this.capture_stones = [];//被吃过子的地方
    this.robotLevel = 0;//机器人级别0-5
    this.stoneToEat = 3;//需要吃几个子才算赢

    this.onKillStone = null;

    if (onKillStone) {
      this.onKillStone = onKillStone;
    }

    this.onResult = null;

    for (var i = 0; i < this.boardSize * this.boardSize; i++) {
      this.stones.push(this.EMPTY);
    }
    /*
    this.markers = this.makeBoardArray(this.EMPTY);
    */
    /*
    this.cache = [];
    this.renderer = renderer || new eidogo.BoardRendererHtml();
    this.lastRender = {
        stones: this.makeBoardArray(null),
        markers: this.makeBoardArray(null)
    };
    */
  },

  clear: function (pt) {
    this.step = 0;
    this.steps = [];
    this.last_kill_pt = null;  //上一手的提子（仅记录一个子的情况，以便做打劫判断）
    //this.stones = this.makeBoardArray(this.EMPTY);
    this.captures = {};
    this.captures.W = 0;
    this.captures.B = 0;
    this.stones = [];
    this.capture_stones = [];
    for (var i = 0; i < this.boardSize * this.boardSize; i++) {
      this.stones.push(this.EMPTY);
    }
  },
  setRobotMode: function (level, stone_toeat, onResult) {//设置机器人级别和吃子多少为赢,结果响应函数
    this.robotLevel = level;
    this.stoneToEat = stone_toeat;
    this.onResult = onResult;

  },

  checkFinished: function () {
    //console.log("checkFinished:B，W",this.captures.B,this.captures.W);
    if (this.captures.W >= this.stoneToEat) {
      //alert("白棋被吃掉三颗子，恭喜您获得胜利！");
      if (this.onResult) {
        this.onResult(true, this.captures.W, this.robotLevel);
      }
      return true;
    }
    else if (this.captures.B >= this.stoneToEat) {
      //alert("黑棋被吃掉三颗子，您输了！");
      if (this.onResult) {
        this.onResult(false, this.captures.B, this.robotLevel);
      }
      return true;
    }else if (this.step > 60){
      if (this.onResult) {
        this.onResult('flat', this.captures.B, this.robotLevel);
      }
      return true;
    }
    return false;
  },
  getSgf: function () {
    //var theCtrl = this;
    /*if(this._mode==GoControl.MODE_PROBLEM){
      return this._sgfData.sgf;
    }
    else{*/

    var sgf = '(;GM[1]SZ[' + this.boardSize + ']PB[GnuGo]PW[W]';

    for (var i = 0; i < this.steps.length; i += 2) {
      sgf += ';B[' + nos_pt2str(this.steps[i]) + ']'; //数字坐标字母坐标

      if (i + 1 < this.steps.length) {
        sgf += ';W[' + nos_pt2str(this.steps[i + 1]) + ']';
      }
    }
    sgf += ')';
    return sgf;
    //}
  },

  //该位置是否被吃过子……人机对弈专用
  isPosInCaputred: function (pt) {
    for (var i = 0; i < this.capture_stones.length; i++) {
      var ptCapture = this.capture_stones[i];
      if (ptCapture.x == pt.x && ptCapture.y == pt.y) {
        return true;
      }
    }
    return false;
  },

  findStep: function (pt) {
    for (var i = this.steps.length; i > 0; i--) {
      if (this.steps[i - 1].x == pt.x && this.steps[i - 1].y == pt.y) {
        return i;
      }
    }
  },

  getLastStepPos: function () {
    if (this.steps.length <= 0) {
      return null;
    }
    return this.steps[this.steps.length - 1];
  },

  makeBoardArray: function (val) {
    // We could use a multi-dimensional array but doing this avoids
    // the need for deep copying during commit, which is very slow.
    //return [].setLength(this.boardSize * this.boardSize, val);
    var list = [];
    for (var i = 0; i < this.boardSize * this.boardSize; i++) {
      list.push(val);
    }
    return list;
  },

  addStone: function (pt, color) {
    this.stones[pt.y * this.boardSize + pt.x] = color;
  },

  //可能值有WHITE,BLACK,EMPTY,null。null代表在棋盘外。
  getStone: function (pt) {
    if (pt.x < 0 || pt.x >= this.boardSize || pt.y < 0 || pt.y >= this.boardSize) {
      return null;
    }
    return this.stones[pt.y * this.boardSize + pt.x];
  },

  getNextColor: function () {
    return this.step2color(this.step + 1);
  },

  getCurrentColor: function () {
    return this.step2color(this.step);
  },

  step2color: function (step) { //step,从1算起。
    if (step % 2 == 1) {
      return this.BLACK;
    }
    return this.WHITE;
  },

  _checkpoint: function (pt, color, known_pt) {
    //若是同色棋子，并且不在known_pt中，则将pt加入known_pt中，再调用_findblock函数。
    //否则不做任何操作。
    if (this.getStone(pt) == color) {
      var is_known = false;
      for (var i = 0; i < known_pt.length; i++) {
        if (known_pt[i].x == pt.x && known_pt[i].y == pt.y) {
          is_known = true;
        }
      }
      if (!is_known) {
        known_pt.push(pt);
        this._findblock(pt, color, known_pt);
        return;
      }
    }
  },

  //递归查找pt所在的棋块
  _findblock: function (pt, color, known_pt) {
    //计算思路：
    //向pt的四个方向看
    //是同色棋子，并且不在known_pt中，则将pt加入known_pt中，再调用此函数。
    //是异色棋子，不做任何操作；
    //是气，则返回null;

    this._checkpoint({
      x: pt.x - 1,
      y: pt.y
    }, color, known_pt);
    this._checkpoint({
      x: pt.x,
      y: pt.y - 1
    }, color, known_pt);
    this._checkpoint({
      x: pt.x + 1,
      y: pt.y
    }, color, known_pt);
    this._checkpoint({
      x: pt.x,
      y: pt.y + 1
    }, color, known_pt);
  },

  //检查pt所在的棋块是否没有气。known_pt：棋块已知棋子
  //是则返回此棋块坐标数组，否则返回null
  findblock: function (pt, color) {
    if (this.getStone(pt) != color) {
      return null;
    }
    var known_pt = [pt];
    this._findblock(pt, color, known_pt);
    return known_pt;
  },

  isblocklive: function (block) {
    //算法：block是已经找出来的完整棋块。周围如果有棋，那么肯定是异色的。所以只要能找出空白点即可。
    for (var i = 0; i < block.length; i++) {
      pt = block[i];
      if (this.EMPTY == this.getStone({
        x: pt.x - 1,
        y: pt.y
      })) {
        return true;
      }
      if (this.EMPTY == this.getStone({
        x: pt.x,
        y: pt.y - 1
      })) {
        return true;
      }
      if (this.EMPTY == this.getStone({
        x: pt.x + 1,
        y: pt.y
      })) {
        return true;
      }
      if (this.EMPTY == this.getStone({
        x: pt.x,
        y: pt.y + 1
      })) {
        return true;
      }
    }
    return false;
  },

  killblock: function (block) {
    var color = this.getStone(block[0]);
    if (this.WHITE == color) {
      this.captures.W += block.length;
    }
    else if (this.BLACK == color) {
      this.captures.B += block.length;
    }
    else {
      console.log('killblock error');
    }


    //把棋盘上相应位置标为empty，还需要记录Chen
    for (var i = 0; i < block.length; i++) {
      pt = block[i];
      this.addStone(pt, this.EMPTY);
      this.capture_stones.push(pt);
    }
    //记录最后一次吃子的情况，以便判断打劫
    if (block.length == 1) {
      this.last_kill_step = this.step;
      this.last_kill_pt = block[0];
    }
    if (this.onKillStone) {
      this.onKillStone(this.captures.B, this.captures.W, block);
    }
  },
  //尝试吃子
  //0：吃到了
  //-1:该位置没找到棋
  //-2:该位置有棋，但未死
  //-3:该位置有棋，但属于打劫例外，不能落子
  trykillblock: function (pt, color, from, step) {
    //找到所在的块
    block = this.findblock(pt, color);
    if (!block) {
      return -1;
    }
    //这块棋是否处于无气状态？
    if (this.isblocklive(block)) {
      return -2;
    }
    //打劫的定义是：
    //判断是否打劫：
    //1.对方无气的棋只有一子；
    //2.对方无气的棋是上一手落子的；
    //3.上一手的提子，恰好就是现在落子的位置
    if (block.length == 1 && this.last_kill_pt) {
      var lastpt = this.steps[this.steps.length - 1];
      if (block[0].x == lastpt.x && block[0].y == lastpt.y) {
        if (this.last_kill_pt.x == from.x && this.last_kill_pt.y == from.y) {
          //return -3;
          if (step - this.last_kill_step == 1) {
            return -3;
          }
        }
      }
    }
    this.killblock(block);
    return 0;
  },

  //落子
  //返回0代表落子成功
  //错误码：
  //-1,pt在棋盘外
  //-2,pt处已有棋子
  //-3,打劫，要隔一步才能落子
  //-4,不允许自杀
  play: function (pt) {
    //如果返回0，这儿step+1，并将pt保存到steps
    //console.log("Logic paly(pt):"+pt.x+","+pt.y+"|"+arguments.callee.caller);
    //console.log("试探:",pt.x,pt.y);
    if (!pt) {
      return -1;
    }

    if (pt.x < 0 || pt.x >= this.boardSize || pt.y < 0 || pt.y >= this.boardSize) {//棋盘外
      return -1;
    }

    if (this.getStone(pt) != this.EMPTY) { //已被棋子占据
      return -2;
    }

    var color = this.getNextColor();
    this.addStone(pt, color);  //设置this.Stone[pt.x*....]=color,先在棋盘上放置此子再来判断。

    //1.对方是否有死子？如有，是否打劫？是则禁手，否则提子并记录，然后返回。
    var block;
    var oppo_color = this.getCurrentColor();//根据this.step返回颜色
    var iskill = false;
    var around = [{
      x: pt.x - 1,
      y: pt.y
    }, {
      x: pt.x,
      y: pt.y - 1
    }, {
      x: pt.x + 1,
      y: pt.y
    }, {
      x: pt.x,
      y: pt.y + 1
    }];
    for (var i = 0; i < around.length; i++) {
      var res = this.trykillblock(around[i], oppo_color, pt, this.step);
      if (res == -3) {
        this.addStone(pt, this.EMPTY); //直接提劫
        return -3;
      }
      if (res == 0) {
        iskill = true;
      }
    }
    if (!iskill) {
      block = this.findblock({
        x: pt.x,
        y: pt.y
      }, color);
      if (!this.isblocklive(block)) {
        this.addStone(pt, this.EMPTY); //自己死棋，回退。
        return -4;
      }
    }

    this.step += 1;
    this.steps.push(pt);
    this.checkFinished();
    console.log('Logic本次下棋坐标和颜色:(' + pt.x + ',' + pt.y + ')|' + color);
    return 0;
  },

  getblockliberty: function (block) {
    var liberties = [];
    //算法：block是已经找出来的完整棋块。周围如果有棋，那么肯定是异色的。所以只要能找出空白点即可。
    for (var i = 0; i < block.length; i++) {
      var pt = block[i];
      var around = [{
        x: pt.x - 1,
        y: pt.y
      }, {
        x: pt.x,
        y: pt.y - 1
      }, {
        x: pt.x + 1,
        y: pt.y
      }, {
        x: pt.x,
        y: pt.y + 1
      }];
      for (var j = 0; j < around.length; j++) {
        if (this.EMPTY == this.getStone(around[j])) {
          for (var k = 0; k < liberties.length; k++) {
            if (liberties[k].x == around[j].x && liberties[k].y == around[j].y) {
              continue;
            }
          }
          liberties.push(around[j]);
        }
      }
    }
    return liberties;
  },

  ///////////////////////////////////////////////////////
  //吃子围棋——人机对弈功能
  ///////////////////////////////////////////////////////
  getRandom: function (max) {
    var random = Math.round(Math.random() * 99999999999);
    return Math.round(random % max);
    var time = (new Date()).getTime();
    return time % max;
  },

  getRandomPos: function (pt, distance) {
    var rx = this.getRandom(2 * distance) - distance;
    var ry = this.getRandom(2 * distance) - distance;
    return {
      x: pt.x + rx,
      y: pt.y + ry
    };
  },


  getNext: function () {
    //回看多少步棋
    var searh_deepth = 30;   //搜索深度，越大越强
    //先检查对方有没有能吃的，能吃立即吃；
    var colores = [this.getCurrentColor(), this.getNextColor()];

    //胆小策略：先看自己有没有危险，能救先救
    //var colores = [ this.getNextColor(),this.getCurrentColor()];

    //有勇无谋：只顾杀对方，不救自己
    //var colores = [ this.getCurrentColor()];

    //胆小如鼠：只救自己，不杀对方
    //var colores = [ this.getNextColor()];

    //是否会瞄准对方气少的棋进攻
    var bTryAttack = true;

    if (this.robotLevel == 0) { //纯粹随机落子
      bTryAttack = false;
      colores = [];//[ this.getNextColor()];
      searh_deepth = 0;
    }
    else if (this.robotLevel == 1) { //只会简单的逃子
      bTryAttack = false;
      colores = [this.getCurrentColor()];
      searh_deepth = 1;
    }
    else if (this.robotLevel == 2) {  //逃子时，看得仔细些了，看到送上门的也能吃
      bTryAttack = false;
      colores = [this.getNextColor(), this.getCurrentColor()];
      searh_deepth = 3;
    }
    else if (this.robotLevel == 3) {  //还会主动发起进攻！
      bTryAttack = true;
      colores = [this.getNextColor(), this.getCurrentColor()];
      searh_deepth = 5;
    }
    else if (this.robotLevel == 4) {  //
      bTryAttack = true;
      colores = [this.getNextColor(), this.getCurrentColor()];
      searh_deepth = 10;
    }
    else if (this.robotLevel == 5) {
      bTryAttack = true;
      colores = [this.getCurrentColor(), this.getNextColor()];
      searh_deepth = 30;
    }

    //todo：增加几个级别：
    //1.会检查有没有双打吃，有则打吃；
    //2.会检查有没有征吃，有则征吃；
    //3.会检查有没有门吃
    //4.枷吃一子
    //5.枷吃多个
    //6.制造吃子条件：分断、双打吃、征吃、门吃、枷吃
    //7.同时制造多种吃子条件
    //8.会保护自己，弱子向空处逃
    //9.会保护自己，弱子连接
    //10.难度动态调整：吃掉小朋友的棋子后，有意降低水平，直到双方比分接近为止
    //11.模拟双方落子，找到能吃到对方的一步棋；
    //12.不那么急功近利，不再是能打吃立即打吃了；
    //13.会主动引诱对方断打自己，形成孤棋
    //14.会把对方往边上、自己的厚实的地方赶去；

    if (this.steps.length == 0) {
      this.play({
        x: this.robotLevel,
        y: this.robotLevel
      });
      return {
        x: this.robotLevel,
        y: this.robotLevel
      };
    }

    var ptDanger = {};
    for (var j = 0; j < colores.length; j++) {
      //算法1：回看之前的N步棋，检查有没有快要死的棋，救之或杀之
      for (var last = this.steps.length - 1; last > 0; last--) {
        if (this.steps.length - last > searh_deepth) {
          continue;
        }
        var ptLast = this.steps[last];
        //var around = [];
        if (this.steps.length >= 2) {
          //var ptExt = this.steps[this.steps.length-2];
          var around = [{
            x: ptLast.x - 1,
            y: ptLast.y
          }, {
            x: ptLast.x,
            y: ptLast.y - 1
          }, {
            x: ptLast.x + 1,
            y: ptLast.y
          }, {
            x: ptLast.x,
            y: ptLast.y + 1
          }];
          //,{x:ptExt.x-1,y:ptExt.y},{x:ptExt.x,y:ptExt.y-1},{x:ptExt.x+1,y:ptExt.y},{x:ptExt.x,y:ptExt.y+1}];

          for (var i = 0; i < around.length; i++) {
            color = colores[j];
            //找到所在的块
            block = this.findblock(around[i], color);
            if (!block) {
              continue;
            }
            //这块棋是否处于无气状态？
            var liberties = this.getblockliberty(block);
            if (liberties.length == 1) {  //只剩一口气的，能杀即杀，能逃即逃
              //alert("binggo!");
              var ptTry = liberties[0];
              if (0 == this.play(ptTry)) {
                return ptTry;
              }
            }
            /*if(liberties.length==2){
              //alert("binggo!");
              return liberties[0];
            }*/
            ptDanger[liberties.length] = liberties[0];
          }
        }
      }
    }
    //算法2：根据之前的检查结果，在气最少的棋旁边落子（救之或攻之）
    if (bTryAttack) {
      for (key in ptDanger) {
        if (key > 4) {	//key是气。太多气的棋，不要试图攻击了
          break;
        }
        var ptTry = ptDanger[key];
        //被提子的地方最好不要落子
        if (this.isPosInCaputred(ptTry)) {
          continue;
        }
        if (0 == this.play(ptTry)) {
          return ptTry;
        }
      }
    }

    //算法3：随机在最后一步的周围，寻找可落子的点
    var ptLast = this.steps[this.steps.length - 1];
    //var ptTry = this.getRandomPos(ptLast,2);
    for (var i = 0; i < 500; i++) {
      var ptTry = this.getRandomPos(ptLast, 1 + Math.floor(i / 2));
      //被提子的地方最好不要落子
      if (this.isPosInCaputred(ptTry)) {
        continue;
      }
      if (0 == this.play(ptTry)) {
        //return nos_pt2str(randomSteps[i]);
        return ptTry;
      }
    }

    //在对方最后落子的位置附近落子
    var randomSteps = [{
      x: ptLast.x - 1,
      y: ptLast.y
    }, {
      x: ptLast.x,
      y: ptLast.y - 1
    }, {
      x: ptLast.x + 1,
      y: ptLast.y
    }, {
      x: ptLast.x,
      y: ptLast.y + 1
    },
      {
        x: ptLast.x - 1,
        y: ptLast.y
      }, {
        x: ptLast.x,
        y: ptLast.y - 1
      }, {
        x: ptLast.x + 1,
        y: ptLast.y
      }, {
        x: ptLast.x,
        y: ptLast.y + 1
      },	//多一行，几率大一些
      {
        x: ptLast.x - 2,
        y: ptLast.y
      }, {
        x: ptLast.x,
        y: ptLast.y - 2
      }, {
        x: ptLast.x + 2,
        y: ptLast.y
      }, {
        x: ptLast.x,
        y: ptLast.y + 2
      }];

    var random = this.getRandom(randomSteps.length);
    for (var i = random; i < (random + randomSteps.length - 1); i++) {
      if (0 == this.play(randomSteps[i])) {
        //return nos_pt2str(randomSteps[i]);
        return randomSteps[i];
      }
    }
    //alert("无处落子。。。认输！");
    return null;
  },
  ///////////////////////////////////////////////////////

  //判断落子是否有效。返回0表示有效，否则返回错误码（可用nos_errormsg获取对应的错误信息）
//注意，此版本下，sgf只能是简化版，不允许分支，也不允许有注释、标注
//如果sgf不合法，会抛出异常。
  nos_ispointok: function (sgf, pt) {
    //var sgf = eidogoPlayer.cursor.getGameRoot().toSgf();
    //var sgf = "(;GM[1]SZ[19]PB[GnuGo]PW[W];B[pc];W[dp];B[pq];W[cc];B[qo];W[pe];B[mc];W[qc];B[qb];W[qd];B[ob];W[qi];B[jq];W[ql])";
    /*   var sz = nos_sgf_getsz(sgf);
       //alert(sz);
       var bgn = sgf.indexOf(";B[");
       if(bgn<0){
           return 0;
       }
       var steplen = 6;
       var pos_bgn = 3;
       var pos_len = 2;

       // debugger;

       var boardtemp = new WGLogic(sz);
       for(var i=bgn;i+pos_bgn+pos_len<sgf.length;i+=steplen){
           var pos = sgf.substr(i+pos_bgn,pos_len);
           if(pos == 'tt'){ //针对弃权情况做特殊处理
               continue;
           }
           var res = boardtemp.play(nos_str2pt(pos));
           if(0!=res){
         return -10;
               throw "param error: sgf not valid(position=" + i + " point=" + pos + " code=" + res + ")";
           }
       }
       //return boardtemp.play(nos_str2pt(pt));
     return boardtemp.play(pt);

     */
    return this.play(pt);
  }

};


function nos_str2pt(str) {
  var codeBase = 'a'.charCodeAt(0);
  return {
    x: str.charCodeAt(0) - codeBase,
    y: str.charCodeAt(1) - codeBase
  };
}

function nos_pt2str(pt) {
  var codeBase = 'a'.charCodeAt(0);
  return String.fromCharCode(codeBase + pt.x) + String.fromCharCode(codeBase + pt.y);
}

function nos_sgf_getsz(sgf) {
  var reg = /SZ\[(\d*)\]/i;
  var res = reg.exec(sgf);
  if (res) {
    return parseInt(res[1]);
  }
  return 19;
}


function nos_errormsg(code) {
  if (code == 0) {
    return '正常';
  }
  else if (code == -1) {
    return '在棋盘外';
  }
  else if (code == -2) {
    return '此处已有棋子';
  }
  else if (code == -3) {
    return '此处打劫，要隔一步才能落子';
  }
  else if (code == -4) {
    return '此处按围棋规则，禁止落子';
  }
  else {
    return '未知错误';
  }
}

export default WGLogic;
